/**
 * E15 限时任务管理 - API 接口
 */
import axiosInstance from '@/api/axiosInstance';
import type { LimitedTask, LimitedTaskListParams } from './types';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

/** 获取限时任务列表 */
export const getLimitedTaskList = async (params: LimitedTaskListParams) => {
  const res = await axiosInstance.get(`${baseUrl}/limitedTask/list`, { params });
  return res.data;
};

/** 获取限时任务详情 */
export const getLimitedTaskDetail = async (id: number) => {
  const res = await axiosInstance.get(`${baseUrl}/limitedTask/detail`, { params: { id } });
  return res.data;
};

/** 创建限时任务 */
export const createLimitedTask = async (data: LimitedTask) => {
  const res = await axiosInstance.post(`${baseUrl}/limitedTask/create`, data);
  return res.data;
};

/** 更新限时任务 */
export const updateLimitedTask = async (data: LimitedTask) => {
  const res = await axiosInstance.post(`${baseUrl}/limitedTask/update`, data);
  return res.data;
};

/** 删除限时任务（逻辑删除） */
export const deleteLimitedTask = async (id: number) => {
  const res = await axiosInstance.post(`${baseUrl}/limitedTask/delete`, { id });
  return res.data;
};

/** 切换启用/禁用状态 */
export const toggleLimitedTaskStatus = async (id: number, status: number) => {
  const res = await axiosInstance.post(`${baseUrl}/limitedTask/toggleStatus`, { id, status });
  return res.data;
};
